// extracted by mini-css-extract-plugin
module.exports = {"mobileFooterImg":"Faq_mobileFooterImg__23IRj","footerImg":"Faq_footerImg__ShSxH"};